import { createAsyncThunk } from "@reduxjs/toolkit";
import { chooseData } from "../../Types/Types";
import axios from "axios";

export const getChooseSimForm = createAsyncThunk(
  "chooseSimForm/getChooseSimForm",
  async (data, thunkApi) => {
    try {
      const response = await axios.get<chooseData[]>(
        "https://api.npoint.io/30afa0d6c39c66001420"
      );

      return response.data;
    } catch (error: any) {
      const message = error.message;
      return thunkApi.rejectWithValue(message);
    }
  }
);
